import { pulinaMoviesUrl } from '../../config/pulinaMoviesBase';

/**
 * Billboard background clips (pulina-movies). On each `/` entry one is chosen at random unless
 * REACT_APP_ADVERT_BG_VIDEO_URL is set in front/.env. The same clip is not chosen twice in a row
 * (sessionStorage).
 */
const ADVERT_BG_MOVIE_KEYS = [
  'ad_movies/ad_bg_loop.mov',
  'ad_movies/thunder_flash.mov',
  'ad_movies/beach_roll.mov',
  'ad_movies/letter_seal_wave.mov',
  'ad_movies/light_streaks.mov',
  'ad_movies/pink_cubes_rotating.mov',
  'ad_movies/purple_grid_loop.mov',
  'ad_movies/snow_flow.mov',
  'ad_movies/teacups.mov',
];

const LAST_ADVERT_BG_KEY_STORAGE = 'pulina_advert_last_bg_movie_key';

export function getAdvertBackgroundVideoUrl() {
  const full = (process.env.REACT_APP_ADVERT_BG_VIDEO_URL || '').trim().replace(/\/$/, '');
  if (full) return full;

  let lastKey = '';
  try {
    lastKey = sessionStorage.getItem(LAST_ADVERT_BG_KEY_STORAGE) || '';
  } catch {
    // ignore (e.g. storage disabled)
  }

  const keys = ADVERT_BG_MOVIE_KEYS;
  const canAvoidRepeat =
    lastKey && keys.includes(lastKey) && keys.length > 1;
  const pool = canAvoidRepeat ? keys.filter((k) => k !== lastKey) : keys;
  const key = pool[Math.floor(Math.random() * pool.length)];

  try {
    sessionStorage.setItem(LAST_ADVERT_BG_KEY_STORAGE, key);
  } catch {
    // ignore
  }

  return pulinaMoviesUrl(key);
}
